import React, {ReactNode} from 'react'
import {BlockSpacerSpOnly, GridContainer, GridItem,} from '../../../../../styledComponents/ResponsiveConvenience'
import {
    DisplayItemInputTitleNoMargin,
    DisplayItemInputTitleRequiredNoMargin
} from '../../../../../styledComponents/DisplayItem'

interface Props {
    title: string | ReactNode
    required?: boolean
    component: ReactNode
}

const NatResidentApplicationDetailFormItem: React.FC<Props> = props => {
    const {title, required, component} = props

    return <GridContainer>
        <GridItem over={3}>
            {required
                ? <DisplayItemInputTitleRequiredNoMargin>{title}</DisplayItemInputTitleRequiredNoMargin>
                : <DisplayItemInputTitleNoMargin>{title}</DisplayItemInputTitleNoMargin>
            }
        </GridItem>
        <GridItem over={9}>
            <BlockSpacerSpOnly height={'10px'}/>
            {component}
        </GridItem>
    </GridContainer>

}

NatResidentApplicationDetailFormItem.displayName = 'NatResidentApplicationDetailFormItem'
export default NatResidentApplicationDetailFormItem